import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'react-html-parser';
import 'LIBRARY/CommonResources/InformationModal/informationmodal.css';

export class InformationModal extends Component {
    render() {
        return (
            <div className={this.props.successModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content successContent">
                        <div className="modal-header modalHeader" id={this.props.successModalType}>
                            <div className="iconContainer" style={{ backgroundColor: this.props.successModalType == 'information' ? '#e8a929' : this.props.successModalType == 'warning' ? '#E65100' : this.props.successModalType == 'error' && '#FF0000' }}>
                                {this.props.successModalType == 'information' ?
                                    <FontAwesomeIcon icon={['fas', 'info-circle']} size="lg" color='#FFFFFF' style={{ fontSize: 20 }} />
                                    :
                                    this.props.successModalType == 'warning' ?
                                        <FontAwesomeIcon icon={['fas', 'exclamation-circle']} size="lg" color='#FFFFFF' style={{ fontSize: 20 }} />
                                        :
                                        <FontAwesomeIcon icon={['fas', 'times-circle']} size="lg" color='#FFFFFF' style={{ fontSize: 20 }} />
                                }
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>{this.props.successModalType} !!!</h3>
                        </div>

                        <div className="modal-body successBody">

                            <p style={{ marginTop: 20, fontSize: 16, textAlign: "center" }}>{ReactHtmlParser(this.props.successMessage)}</p>

                        </div>

                        <div className="modal-footer successFooter">
                            <button className="btn" style={{ color: '#FFFFFF', backgroundColor: this.props.successModalType == 'information' ? '#e8a929' : this.props.successModalType == 'warning' ? '#E65100' : this.props.successModalType == 'error' && '#FF0000' }} onClick={() => this.props.closeSuccessModal()}>{this.props.successModalType == 'information' ? 'Continue' : this.props.successModalType == 'warning' ? 'Close' : this.props.successModalType == 'error' && 'Close'}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default InformationModal
